module.exports = __webpack_public_path__ + "img/PHA.613f4aab.png";